var e={exports:{}};export{e as __module};
//# sourceMappingURL=index3.js.map
